import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import { saasIsolationLicense } from '../../productLicense';
import BrowserPoliciesStore from '../../stores/BrowserPolicies/BrowserPoliciesStore';
import ConsoleStore from '../../stores/ConsoleStore';
import { ConsoleCardHeader, ConsolePage, ConsoleTable } from '../ConsoleFragments';
import ConsoleCard from '../ConsoleFragments/ConsoleCard';
import FuseInfoTooltip from '../FuseControls/FuseTooltip/FuseInfoTooltip';
import BrowserPolicyModal from './BrowserPolicyModal';
import SnackStore from '../../stores/SnackStore';
import MoreMenu from '../Menu/MoreMenu';
import TextWithTitle from '../ConsoleFragments/TextWithTitle';
import Button from '../Button';
import AccessCodesTable from '../AccessCodes/AccessCodesTable';
import AccessCodesEditModal from '../AccessCodes/AccessCodesEditModal';
import AccessCodeActionModal from '../AccessCodes/AccessCodeActionModal';
import DeleteBrowserPolicyModal from './DeleteBrowserPolicyModal';
import { ROLE_READ_ONLY } from '../../stores/Administrators/AdministratorModalStore';
import './BrowserPolicies.css';

const block = b.lock('BrowserPolicies');

class BrowserPolicies extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
        browserPolicies: BrowserPoliciesStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    componentWillMount() {
        this.props.browserPolicies.load()
            .catch((error) => error && this.props.snack.showError(`Failed to load policy list. ${error.message}`));
    }

    columns = [{
        name: 'name',
        title: 'Policy Name',
        render: (policy) => (policy.isDefault ? <Fragment>
            <strong>Default Policy</strong>
            <FuseInfoTooltip inline>
                The default policy is a system generated policy and cannot be deleted.
            </FuseInfoTooltip>
        </Fragment> : policy.name),
    }, {
        name: 'total_activations',
        title: 'Total Activations',
        render: (policy) => <TextWithTitle text={policy.isDefault ? '' : policy.totalActivations} />,
    }, {
        name: 'menu',
        title: '',
        render: (policy) => {
            const readOnly = this.isReadOnly();
            return <MoreMenu
                menuId={policy.id}
                menuStore={this.props.browserPolicies.menu}
            >
                {!readOnly ? (
                    <MoreMenu.Item
                        icon={'edit'}
                        onClick={() => this.props.browserPolicies.showUpdate(policy)}
                    >Edit Policy…</MoreMenu.Item>
                ) : (
                    <MoreMenu.Item
                        icon={'view'}
                        onClick={() => this.props.browserPolicies.showView(policy)}
                    >View Policy…</MoreMenu.Item>
                )}
                <MoreMenu.Item
                    icon={'delete'}
                    onClick={() => this.props.browserPolicies.showDelete(policy)}
                    disabled={policy.isDefault || readOnly}
                >Delete Policy…</MoreMenu.Item>
            </MoreMenu>;
        },
    }];


    expandedSection = {
        canExpand: (policy) => !policy.isDefault,
        isExpanded: (policy) => this.props.browserPolicies.policyExpandedRow === policy.id,
        toggleExpand: (policy) => {
            this.props.browserPolicies.togglePolicyExpand(policy);
        },
        render: (policy) => (
            <AccessCodesTable policy={policy} readOnly={this.isReadOnly()} />
        ),
    };

    isReadOnly() {
        return this.props.console.authority === ROLE_READ_ONLY.value;
    }

    render() {
        const title = this.props.console.onlyWebmail
            ? 'Email Isolation — Policies'
            : 'Browser Isolation — Policies';

        return <ConsolePage title={title}>
            <ConsoleCard>
                <ConsoleCardHeader title="Manage Policies">
                    {!this.isReadOnly() ? <Button
                        raised
                        primary
                        onClick={this.props.browserPolicies.showCreate}
                        icon="add"
                        disabled={this.props.browserPolicies.listStatus.isLoading}
                    >NEW POLICY</Button> : null}
                </ConsoleCardHeader>
                <ConsoleTable
                    columns={this.columns}
                    items={this.props.browserPolicies.policies}
                    cellClassName={block('Cell')}
                    focusedItemId={this.props.browserPolicies.menu.id}
                    expandedSection={this.expandedSection}
                    loading={this.props.browserPolicies.listStatus.isLoading}
                />
            </ConsoleCard>

            <BrowserPolicyModal
                hideUiSection={this.props.console.license === saasIsolationLicense}
            />
            <AccessCodesEditModal />
            <AccessCodeActionModal
                title="Delete Access Code"
                headerActionText="DELETE"
                checkboxLabel="deleted"
                isOpen={this.props.browserPolicies.accessCodesEditStore.isDeleteModalOpen()}
            />
            <AccessCodeActionModal
                title="Deactivate Access Code"
                headerActionText="DEACTIVATE"
                checkboxLabel="deactivated"
                isOpen={this.props.browserPolicies.accessCodesEditStore.isDeactivateModalOpen()}
            />
            <DeleteBrowserPolicyModal />
        </ConsolePage>;
    }
}

export default inject('console', 'browserPolicies', 'snack')(observer(BrowserPolicies));
